import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Text } from 'foundations-components/components/Text';
import { getNewSnippetsUrl } from 'hubspot-prosemirror/prosemirror/utils/manageLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ContentPopoverEmptyState({
  portalId,
  openUrl
}) {
  const openLinkHandler = () => {
    const url = getNewSnippetsUrl(portalId);
    openUrl(url);
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "center",
    padding: "200",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "text-snippet",
      height: 150,
      width: 150,
      marginBlockEnd: "300"
    }), /*#__PURE__*/_jsx(H5, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "draftPlugins.snippetsPlugin.popover.emptyState.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      typography: "body-200",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "draftPlugins.snippetsPlugin.popover.emptyState.description"
      })
    }), /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      external: true,
      onClick: openLinkHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "draftPlugins.snippetsPlugin.popover.emptyState.createFirstSnippet"
      })
    })]
  });
}
export default ContentPopoverEmptyState;